<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <vs-button
         v-if="$acl.check('admin')"
        type="border"
          color="danger"
          class="float-right ml-2"
          @click="deleteReport"
          icon="delete"
        >{{$t('Delete') | ToUppercase}}</vs-button>
        <vs-button
        v-if="$acl.check('admin') && !1"
          color="primary"
          class="float-right ml-2"
          @click="editReport"
          type="border"
          icon="build"
        >{{$t('Edit') | ToUppercase}}</vs-button>
      </div>
      <div class="vx-col w-full mb-2">
        <vx-card :title="$t('ReportData') |ToUppercase">
          <table class="userDataTable">
            <tr>
              <td class="fontSemibold">{{$t('Filename') |ToUppercase}}</td>
              <td><vs-button @click="downloadFile">{{ report.filename }}</vs-button></td>
            </tr>
            <tr>
              <td class="fontSemibold">{{$t('Datetime') |ToUppercase}}</td>
              <td>{{ report.datetime | moment("D. M. YYYY, hh:mm") }}</td>
            </tr>
            <tr>
              <td class="fontSemibold">{{$t('Shift') |ToUppercase}}</td>
              <td v-if="report.shift.name != ''">{{ report.shift.name}}, {{ report.shift.datetime | moment("D. M. YYYY")}}</td>
              <td v-if="report.shift.name == ''">{{$t('NoData')}}</td>
            </tr>
            <tr>
              <td class="fontSemibold">{{$t('User') |ToUppercase}}</td>
              <td>{{ report.user.firstname + ' ' + report.user.lastname}} ({{report.user.username}})</td>
            </tr>
          </table>
        </vx-card>
      </div>
    </div>
    <vs-popup :title="$t('DeleteShiftAlert') |ToUppercase" :active.sync="showDeleteAlert">
      <vs-row vs-justify="center" class="mt-2">
        <vs-button
          color="primary"
          type="filled"
          class="mx-2"
          @click="showDeleteAlert = false"
        >{{$t('Cancel') |ToUppercase}}</vs-button>
        <vs-button color="danger" type="filled" @click="acceptDeletion">{{$t('Remove') |ToUppercase}}</vs-button>
      </vs-row>
    </vs-popup>
  </div>
</template>
<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    },
  },
  data() {
    return {
      id: 0,
      report: {},
      selected: "",
      showDeleteAlert: false,
      hasAcceptedDeletion: false
    };
  },
  methods: {
    async loadData() {
      try {
        let response = await this.$store.dispatch(
          "report/fetchReport",
          this.id
        );
        this.report = response.data;
        console.log(this.report);
        console.log(this.report.document.base64);
      } catch (error) {
        console.log(error.response.data);
        if (
          error.response.data.code == 404 ||
          error.response.data.code == 500
        ) {
          this.$router.push(
            `../pages/error?error=${error.response.data.error}&code=${
              error.response.data.code
            }&button=${this.$t(
              "BackToUsersButton"
            )}&link=/user/all/`
          );
        }
        console.log(error.response.data);
        this.$vs.notify({
          title: this.$t("Error"),
          text: error.response.data.error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          time: 3000
        });
      }
    },
    editReport() {
      this.$router.push(`/report/edit/${this.id}`);
    },
    async acceptDeletion() {
      this.showDeleteAlert = false;
      this.hasAcceptedDeletion = true;
      await this.deleteReport();
    },
    async deleteReport() {
      if (!this.hasAcceptedDeletion) {
        this.showDeleteAlert = true;
        return;
      }

      this.$vs.loading();
      try {
        let result = await this.$store.dispatch(
          "report/deleteReport",
          this.id
        );
        this.$vs.notify({
          title: this.$t("SuccessfullyRemoved"),
          text: this.$t("UserSuccessfullyRemoved"),
          iconPack: "feather",
          icon: "icon-check-circle",
          color: "success"
        });

        setTimeout(() => {
          this.$router.push(`/report/all`);
        }, 200);
      } catch (error) {
        this.$vs.notify({
          title: this.$t("Error"),
          text: error,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      } finally {
        this.$vs.loading.close();
      }
    },
    downloadFile(){
        console.log(this.report.document.fileB);
        var arr = base64ToArrayBuffer(this.report.document.fileB);
        saveByteArray(arr, this.report.filename);
    }
  },
  async created() {
    this.id = this.$route.params.report_id;
    this.$vs.loading();
    await this.loadData();
    this.$vs.loading.close();
  }
};

function base64ToArrayBuffer(base64) {
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
       var ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

function saveByteArray(byte, reportName, mime) {
    var blob = new Blob([byte]);
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
};
</script>
<style>
.fontSemibold {
  font-weight: 600 !important;
}
.userDataTable {
  white-space: nowrap;
}

.userDataTable td:first-child {
  min-width: 160px;
}

.IDImageWrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.userImage {
  max-height: 400px;
}
.userIDImage {
  max-height: 180px;
}
.center {
  justify-content: center;
  display: flex;
  width: 100%;
}

@media (min-width: 768px) {
  .image {
    width: 100%;
    object-fit: contain;
  }
}
.imageWrapper {
  height: 14em;
  overflow: hidden;
  float: left;
}
.image {
  width: 100%;
  object-fit: cover;
}

.success {
  color: black;
  background: rgb(23, 201, 100) !important;
  box-shadow: 0px 15px 40px -10px rgba(23, 201, 100, 0.9);
}
.danger {
  color: black;
  background: rgb(242, 19, 93) !important;
  box-shadow: 0px 15px 40px -10px rgba(242, 19, 93, 0.9);
}
.warning {
  color: black;
  background: rgb(255, 130, 0) !important;
  box-shadow: 0px 15px 40px -10px rgba(255, 130, 0, 0.9);
}
</style>